import React from 'react'
import { MdInfo } from 'react-icons/md'

export default function DisclaimerBox({ label, value, highlightClass = 'highlight-disclaimer' }) {
  return (
    <div className="disclaimer-box">
      <p className="result-label">
        <MdInfo />
        {label}
      </p>
      <p className={`result-value ${highlightClass}`}>{value}</p>
    </div>
  )
}
